"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _AbstractButton = _interopRequireDefault(require("./AbstractButton"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = exports.default = (0, _AbstractButton.default)('SendEmailButton', (classes, props) => {
  const url = 'mailto:' + props.to + '?subject=' + (props.subject || '') + (props.bcc ? '&bcc=' + props.bcc : '');
  return /*#__PURE__*/_react.default.createElement("a", {
    href: url,
    className: classes.join(' '),
    onClick: props.onClick
  }, props.children);
});